const toCSV = require("json2csv");

/**
 * @description Parse array of objects to CSV
 * @param {Array<object>} json
 */
export const parseJSONToCSV = (json) => toCSV.parse(json);
